var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownToLine = function SvgDownToLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.4 19.2h-.6v1.2h14.4v-1.2H5.4M13.8 9v1.2h3v.663l-4.8 4.32-4.8-4.32V10.2h3V4.8h3.6zM18 9h-3V3.6H9V9H6v2.4l6 5.4 6-5.4V9"
  })));
};
export default SvgDownToLine;